import { connect } from 'react-redux'
import ProviderProductDeactivatedListPane from '../../components/products/ProviderProductDeactivatedListPane'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState) => {
  return {}
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductDeactivatedListPane)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductDeactivatedListPane.ts